import type { WhatsNewBody } from '../types';

export default {
  title: 'Export a submittal onto the company transmittal',
  summary:
    'A submittal can now be exported to Excel onto the company’s submittal transmittal, already filled in for the round you are on and ready to attach in Outlook.',
  details: [
    'Boxes that need a person stay yellow or unticked for you to fill in.',
    'Date stays blank until the round is marked sent. After a Revise & Resubmit, the form is already for the next Rev.',
  ],
  audience: { label: 'project managers and engineers', test: (a) => a.editsProjects },
  tryIt: { to: '/projects', label: 'Open Projects' },
  guide: { topic: 'mod-submittals-export' },
} satisfies WhatsNewBody;
